import React from "react";
import { useLang } from "../../context/lang-context";

const LandingPartners: React.FC = () => {
  const { t } = useLang();

  const features = [
    t("Punto de Venta", "Point of Sale System"),
    t("Recibe Órdenes Online Sin Comisiones", "Get Online Orders With No Commissions"),
    t("Tu Propia Página Web", "Your Own Website"),
    t("Reportes de Venta en Vivo", "Live Sales Reports"),
    t("Recibe Pagos con Tarjeta", "Accept Credit Card Payments"),
  ];

  return (
    <section className="partners-section" id="empresas">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-10 col-md-5 text-center mb-4 mb-md-0">
            <img
              src="/img/landing_samsung_galaxy@0.5x.png"
              alt={t("Foo para Empresas", "Foo for Business")}
              className="partners-device"
            />
          </div>
          <div className="col-12 col-md-6 text-center text-md-start">
            <h2 className="partners-title">
              {t("¿Tienes Restaurante?", "Do You Own a Restaurant?")}
            </h2>
            <p className="partners-subtitle">
              {t(
                "Conoce las herramientas que Foo para Empresas tiene para tu negocio.",
                "See what Foo for Business can do for your business."
              )}
            </p>
            <ul className="partners-list">
              {features.map((f, i) => (
                <li key={i}>
                  <i className="fas fa-check-circle"></i> {f}
                </li>
              ))}
            </ul>
            <a
              href="https://partner.fooapp.mx"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-dark btn-lg partners-cta"
            >
              {t("Conoce Foo para Empresas", "Go to Foo for Business")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingPartners;
